import script from "./SideBarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=35d35028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d35028"]])

export default __exports__